
























import Vue from "vue";
import vIcon from "../v-components/v-icon.vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "Dialog",
  components: { vIcon },
  data: () => {
    return {
      currentComponent: null as null
    };
  },
  computed: {
    ...mapGetters(["GET_DIALOG_STATUS"])
  },
  watch: {
    GET_DIALOG_STATUS(state): void {
      state.component ? (this.loadComponent(), this.focusToElement()) : null;
    }
  },
  methods: {
    handleDismissDialog(): void {
      this.$store.dispatch("UPDATE_DIALOG_STATUS", {
        status: false,
        component: ""
      });
    },

    focusToElement(): void {
      Vue.nextTick(() => {
        ((this.$refs.close as
          | Vue
          | Element
          | Vue[]
          | Element[]) as HTMLElement).focus();
      });
    },

    loadComponent(): void {
      const component: string = this.GET_DIALOG_STATUS.component;
      import(
        `@/components/dialogs/Dialog${component
          .charAt(0)
          .toUpperCase()}${component.slice(1)}.vue`
      )
        .then(res => (this.currentComponent = res.default))
        .catch(error => console.log(error));
    }
  }
});
